// ページネーションのコンポーネント
import * as React from "react";
import { Link } from "gatsby";
import { Button, Flex, Spacer } from "@chakra-ui/react";

const Pagination = ({ currentPage, maxPage, pagePath }) => {
  return (
    <Flex>
      {currentPage === 1 ? (
        // show hide button
        <Button isDisabled colorScheme="gray" variant="outline">
          前のページ
        </Button>
      ) : (
        <Link
          to={currentPage === 2 ? pagePath : `${pagePath}/${currentPage - 1}`}
        >
          <Button colorScheme="teal" variant="outline">
            前のページ
          </Button>
        </Link>
      )}
      <Spacer />
      {currentPage === maxPage ? (
        <Button isDisabled colorScheme="gray" variant="outline">
          次のページ
        </Button>
      ) : (
        <Link to={`${pagePath}/${currentPage + 1}`}>
          <Button colorScheme="teal" variant="outline">
            次のページ
          </Button>
        </Link>
      )}
    </Flex>
  );
};

export default Pagination;
